import { useContext, useState } from 'preact/hooks';
import { SessionContext } from '../app.jsx';
import { post } from '../api.js';
import { Field, useForm } from '../ui/Field.jsx';
import { Entry } from './Login.jsx';

export function Setup() {
  const { refresh } = useContext(SessionContext);
  const [f, bind] = useForm({ name: '', username: '', password: '', again: '' });
  const [mismatch, setMismatch] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setMismatch(f.password !== f.again);
    if (f.password !== f.again) return;
    setBusy(true);
    try {
      await post('/setup', { name: f.name, username: f.username, password: f.password });
      await refresh();
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Entry>
      <form class="stack-form" onSubmit={submit}>
        <h1>Dobro došli u Wild Serbia</h1>
        <p>Ovaj nalog postaje nalog kancelarije. Kasnije iz njega praviš naloge za vodiče.</p>
        <Field label="Ime i prezime"><input {...bind('name')} autocomplete="name" required /></Field>
        <Field label="Korisničko ime">
          <input {...bind('username')} autocomplete="username" autocapitalize="none" spellcheck={false} required />
        </Field>
        <Field label="Lozinka"><input {...bind('password')} type="password" autocomplete="new-password" required /></Field>
        <Field label="Ponovi lozinku" error={mismatch && 'Lozinke se ne poklapaju.'}>
          <input {...bind('again')} type="password" autocomplete="new-password" required />
        </Field>
        {error && <p class="alert" role="alert">{error}</p>}
        <button class="btn" disabled={busy}>Napravi nalog kancelarije</button>
      </form>
    </Entry>
  );
}
